/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getBackorders, GetBackordersrApiParameter } from "@pacific/App/Services/BackordersService";
import { BackorderModel } from "@pacific/XDL/types";

interface Props {
    apiParameter: GetBackordersrApiParameter;
    apiResult: { backOrders?: BackorderModel[] };
}

type Parameter = GetBackordersrApiParameter;

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingRequest: HandlerType = props => {
    props.dispatch({
        type: "Backorders/SetIsLoading",
        parameter: props.parameter,
        isLoading: true,
    } as any);
};

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBackorders(props.apiParameter);
};

export const DispatchCompleteLoadBackorders: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch({
            type: "Backorders/SetBackorders",
            backorders: props.apiResult.backOrders,
            parameter: props.parameter,
        } as any);
    }
};

export const chain = [BeginLoadingRequest, DispatchBeginAction, RequestDataFromApi, DispatchCompleteLoadBackorders];

const loadBackorders = createHandlerChainRunner(chain, "LoadBackorders");
export default loadBackorders;
